/** Shopify CDN: Minification failed

Line 7:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 8:2 Transforming const to the configured target environment ("es5") is not supported yet

**/
const loadingCustomilyTimeOut = setInterval(() => {
  const customilyElement = document.querySelector("#customily-options");
  if (customilyElement) {
    // handling logic
    console.log("hello there");
    setTimeout(function (){
      document.querySelector("#loading_element").style = "display: none;";
    },500)
    clearInterval(loadingCustomilyTimeOut);
  }
}, 100);
